export { ChartPage as default } from '@/components/enpages/Ir/Financial/Chart'
